module.exports = __webpack_public_path__ + "manageStatic/img/logo_ios.348e8008.png";